import { Paper } from 'shared/ui/paper'
import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

export const DirectionCardSkeleton = () => {
  return (
    <Paper padding={[8, 16]}>
      <div className={s.skeletonContainer}>
        <Skeleton
          width={40}
          height={40}
          borderRadius={'100%'}
        />

        <div className={s.names}>
          <Skeleton
            height={20}
            width={'80%'}
            borderRadius={6}
          />
        </div>
      </div>
    </Paper>
  )
}
